/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Limit_1_ValueInputs */

const en_svc_n8n_limit_1_value = /** @type {(inputs: Svc_N8n_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every workflow is documented and readable by your team.`)
};

const lv_svc_n8n_limit_1_value = /** @type {(inputs: Svc_N8n_Limit_1_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katra darba plūsma ir dokumentēta un saprotama Jūsu komandai.`)
};

/**
* | output |
* | --- |
* | "Every workflow is documented and readable by your team." |
*
* @param {Svc_N8n_Limit_1_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_limit_1_value = /** @type {((inputs?: Svc_N8n_Limit_1_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Limit_1_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_limit_1_value(inputs)
	return en_svc_n8n_limit_1_value(inputs)
});